export default function errorHandler(err, vueApp, info) {
  const componentNames = `${getComponentNames(vueApp?.$parent || null)} > ${
    vueApp?.$options?.name || 'UNNAMED'
  }`
  console.error(
    `%c ERROR IN ${info}: ${componentNames}`,
    'font-weight: bold;',
    ', details below\n',
    err,
  )
}

const getComponentNames = function (cmp) {
  if (cmp && cmp.$parent) {
    let value = getComponentNames(cmp?.$parent)
    if (value.length && cmp?.$options?.name) {
      value += ' > '
    }
    return `${value}${cmp?.$options?.name || ''}`
  } else {
    return cmp?.$options?.name || ''
  }
}
